<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<h2 class="text-h5 mb-4">System Support and Maintenance</h2>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="3">
				<v-card class="text-left" hover link :to="{ path: '/SSAM/hovers' }">
					<v-card-item>
						<template #prepend>
							<v-icon color="primary" size="40">mdi-cursor-default-click</v-icon>
						</template>
						<v-card-title>Hover Management</v-card-title>
						<v-card-subtitle>Manage hover options for policy navigation</v-card-subtitle>
					</v-card-item>
					<v-card-text>
						Add, view, and manage default and user-specific hover options for policy processing, claims, and receivables.
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="3">
				<v-card class="text-left" hover link :to="{ path: '/SSAM/groups' }">
					<v-card-item>
						<template #prepend>
							<v-icon color="primary" size="40">mdi-account-group</v-icon>
						</template>
						<v-card-title>Group Management</v-card-title>
						<v-card-subtitle>Manage groups and user assignments</v-card-subtitle>
					</v-card-item>
					<v-card-text>
						Create, update, and delete authorization groups. Assign and remove users from groups.
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="3">
				<v-card class="text-left" hover link :to="{ path: '/SSAM/menus' }">
					<v-card-item>
						<template #prepend>
							<v-icon color="primary" size="40">mdi-menu</v-icon>
						</template>
						<v-card-title>Command Center Menus</v-card-title>
						<v-card-subtitle>Manage menu items and navigation</v-card-subtitle>
					</v-card-item>
					<v-card-text>
						Add, update, and delete command center menu items for POINT and Operation applications.
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="3">
				<v-card class="text-left" hover link :to="{ path: '/SSAM/rsm-updates' }">
					<v-card-item>
						<template #prepend>
							<v-icon color="primary" size="40">mdi-account-switch</v-icon>
						</template>
						<v-card-title>RSM Management</v-card-title>
						<v-card-subtitle>Manage regional sales assignments</v-card-subtitle>
					</v-card-item>
					<v-card-text>
						Add, update, and delete DMM/RSM assignments, sales fields, and region descriptions.
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="3">
				<v-card class="text-left" hover link :to="{ path: '/SSAM/underwriters' }">
					<v-card-item>
						<template #prepend>
							<v-icon color="primary" size="40">mdi-account-tie</v-icon>
						</template>
						<v-card-title>Underwriter Management</v-card-title>
						<v-card-subtitle>Manage and provision underwriters</v-card-subtitle>
					</v-card-item>
					<v-card-text>
						View all underwriters and provision new underwriter accounts with group profiles.
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script lang="ts">
export default {
	name: 'SsamHome',
	route: {
		path: '/SSAM',
		meta: {
			requiresAuth: true,
			title: 'System Support and Maintenance',
		},
	},
	setup() {
		return {};
	},
};
</script>
